export const colorMap = {
  'azul-escuro': '#3d489b',
  azul: '#4892DF',
  verde: '#3BBF9F',
  cinza: '#A6B1B4',
  'cinza-solido': '#f2f2f2',
  vermelho: '#FF5E5E',
  laranja: '#FF9A38',
  amarelo: '#FFFF00',
  roxo: '#800080',
  dourado: '#b99c56',
  'azul-marinho': '#1C7FBC',
  'azul-solido': '#315694',
  marrom: '#673C0D',
  branco: '#FFFFFF',
};

export const resolveColor = (cor, fallback = '#3d489b') =>
  colorMap[cor] || cor || fallback;

export const resolveClientColor = () => {
  const cor1 = localStorage.getItem('cliente_cor1');
  if (cor1 === 'outra') return localStorage.getItem('cliente_cor_custom') || '#3d489b';
  return colorMap[cor1] || cor1 || '#3d489b';
};

const parseColor = (color) => {
  if (!color || typeof color !== 'string') return null;

  const value = color.trim().toLowerCase();
  const hex = value.match(/^#([\da-f]{3}|[\da-f]{6})$/i);
  if (hex) {
    const normalized = hex[1].length === 3
      ? hex[1].split('').map((part) => `${part}${part}`).join('')
      : hex[1];
    return [0, 2, 4].map((index) => parseInt(normalized.slice(index, index + 2), 16));
  }

  const rgb = value.match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/);
  return rgb ? rgb.slice(1, 4).map(Number) : null;
};

export const getContrastColor = (background, light = '#ffffff', dark = '#1c1d21') => {
  const rgb = parseColor(background);
  if (!rgb) return dark;

  const luminance = rgb.reduce((total, channel, index) => {
    const normalized = channel / 255;
    const linear = normalized <= 0.03928
      ? normalized / 12.92
      : ((normalized + 0.055) / 1.055) ** 2.4;
    return total + linear * [0.2126, 0.7152, 0.0722][index];
  }, 0);

  return luminance > 0.48 ? dark : light;
};
